export const getTranslatedSearchTerm = (response) =>
  typeof response?.data?.translated_search_term === "string"
    ? response.data.translated_search_term.trim()
    : "";

export const canReuseSearchAnalytics = (analytics, queryKey) =>
  typeof queryKey === "string" && queryKey.length > 0 &&
  ["analytics_per_collection", "analytics_per_collection_arabic"].every(name =>
    Array.isArray(analytics?.[name]?.buckets) &&
    analytics[name].sum_other_doc_count === 0
  );

